// extracted by mini-css-extract-plugin
export default {"wrapper":"AcceptedUnderInfo__wrapper--K9T-7"};